import React from 'react';
import { Text } from './Text';

interface ErrorTextProps {
    children: React.ReactNode;
}

export function ErrorText({ children }: ErrorTextProps) {
    return (
        <Text size="sm" tone="error">
            {children}
        </Text>
    );
}
